import { useQuery } from '@tanstack/react-query';
import { API } from 'api';
import { PlanetLabsRasterTileset } from 'features/planetLabs/planetLabs.types';
import { useReleaseFlag } from 'hooks/useReleaseFlags';
import { useAuthState } from 'state/useAuthState';

const fetchPlanetLabsRasterTilesets = async (): Promise<
  PlanetLabsRasterTileset[]
> => {
  const result = await API.get<PlanetLabsRasterTileset[]>(
    `feature_layer_mirrors/planet_labs/`,
  );
  return result.data;
};

export const usePlanetLabsRasterTilesets = (): PlanetLabsRasterTileset[] => {
  const { isOrganizationUser } = useAuthState();
  const showSatelliteBasemap = useReleaseFlag(
    'show_planet_labs_satellite_basemap_in_frontend',
  );

  const { data = [] } = useQuery<PlanetLabsRasterTileset[]>({
    queryKey: ['planetLabsRasterTilesets'],
    queryFn: () => fetchPlanetLabsRasterTilesets(),
    staleTime: 1000 * 86400, // 1 day
    // Only organization users have access to Planet Labs tilesets, so don't bother
    // with a request otherwise.
    enabled: isOrganizationUser && showSatelliteBasemap,
  });

  // Return the data if the user is an organization user, otherwise return an empty array, since
  // useQuery may return cached data even when disabled.
  return isOrganizationUser && showSatelliteBasemap ? data : [];
};
